// src/services/firebase.js
// Firebase es opcional — la autenticación principal va por el backend (PostgreSQL).
// Si las credenciales de Firebase no están configuradas, la app funciona sin social login.

let auth = null;
let googleProvider = null;
let firebaseEnabled = false;

try {
    const apiKey = process.env.REACT_APP_FIREBASE_API_KEY;
    if (apiKey && apiKey !== 'undefined' && apiKey.length > 10) {
        const { initializeApp } = require("firebase/app");
        const { getAuth, GoogleAuthProvider } = require("firebase/auth");

        const firebaseConfig = {
            apiKey,
            authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
            projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
            storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
            messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
            appId: process.env.REACT_APP_FIREBASE_APP_ID,
            measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
        };

        const app = initializeApp(firebaseConfig);
        auth = getAuth(app);

        googleProvider = new GoogleAuthProvider();
        googleProvider.setCustomParameters({ prompt: "select_account" });
        firebaseEnabled = true;
    } else {
        if (process.env.NODE_ENV !== 'production') {
            console.info('[MyHoomy] Firebase no configurado — usando solo autenticación por backend.');
        }
    }
} catch (e) {
    console.warn('[MyHoomy] Firebase no se pudo inicializar:', e.message);
}

export { auth, googleProvider, firebaseEnabled };
